<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-clipboard-text"
      icon-small
      title="تعریف وام ها"
      color="accent"
    >
      <template v-slot:topActons>
        <v-btn
          color="primary"
          dark
          @click="add"
        >
          <v-icon dark>
            mdi-plus-circle-outline
          </v-icon>
          افزودن وام
        </v-btn>
      </template>
      <v-data-table
        :headers="headers"
        :items="loans"
        :items-per-page="5"
        class="elevation-1"
      >
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.code }}</td>
            <td>{{ row.item.title }}</td>
            <td class="text-center">
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="secondary"
                @click="edit(row.item)"
              >
                <v-icon dark>
                  mdi-square-edit-outline
                </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="pink"
                @click="remove(row.item)"
              >
                <v-icon dark>
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">اطلاعات وام</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form
                ref="form"
                class="mx-2"
                lazy-validation
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      ref="code"
                      v-model="localData.code"
                      label="شماره*"
                      :error-messages="errorMessages"
                      :rules="[() => !!localData.code || 'شماره وام را وارد کنید']"
                      required
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      ref="title"
                      v-model="localData.title"
                      label="عنوان*"
                      :error-messages="errorMessages"
                      :rules="[() => !!localData.title || 'عنوان وام را وارد کنید']"
                      required
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*فیلدهای ستاره دار ضروری هستند.</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="dialog = false"
            >
              بستن
            </v-btn>
            <v-btn
              color="blue"
              dark
              @click="submit()"
            >
              ذخیره
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import { emptyId } from '@/util/emptyId'
  import api from '@/util/app-api'
  import toast from '@/util/toast'

  export default {
    name: 'RegularTablesView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        selectedItem: null,
        dialog: false,
        headers: [
          {
            text: 'شماره',
            align: 'start',
            sortable: true,
            value: 'code',
          }, {
            text: 'عنوان',
            align: 'start',
            sortable: true,
            value: 'title',
          }, {
            text: 'عملیات',
            align: 'center',
            sortable: false,
            width: 200,
          },
        ],
        loans: [],
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        api.get('admin/loan/list', null)
          .then(
            response => {
              this.loans = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      add () {
        this.localData = { id: emptyId, title: '' }
        this.dialog = true
      },
      edit (item) {
        this.selectedItem = item
        api.get('admin/loan/get/' + item.id, null)
          .then(
            response => {
              this.localData = response
              this.dialog = true
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      submit () {
        if (!this.$refs.form.validate()) { return }

        api.post('admin/loan/' + (this.localData.id === emptyId ? 'create' : 'edit'), this.localData)
          .then(
            response => {
              toast.success('اطلاعات با موفقیت ذخیره شد.')
              this.loadData()
              this.dialog = false
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      async remove (item) {
        if (!item) { return }

        if (await this.$refs.confirm.open(
          'توجه',
          'آیا از حذف این آیتم مطمئن هستید؟',
        )) {
          api.post('admin/loan/delete/' + item.id)
            .then(
              response => {
                toast.success('اطلاعات با موفقیت حذف شد.')
                this.loadData()
              })
            .catch(err => {
              toast.error(err.message)
            })
        }
      },
    },
  }
</script>
